import { AccountType } from '@/data/usecases/account/account-type'
import { AccountModel } from '@/domain/models/account/account-model'
import { DocumentType } from '@/domain/models/document/document-type'

export const showDependentRequestButton = (account: AccountModel): boolean => {
  return (
    !!account.passPlan &&
    AccountType.Enum.COLLABORATOR.is(account) &&
    account.company.allowDependents &&
    DocumentType.Enum.CPF.is(account.document)
  )
}
